import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PlatePrice } from '@paragon/contract-library';

const initialState: { [guid: string]: PlatePrice } = {};

const platePricesSlice = createSlice({
  name: 'platePrices',
  initialState,
  reducers: {
    setPlatePrices: (state, action: PayloadAction<readonly PlatePrice[]>) => {
      for (const platePriceRecord of action.payload) {
        state[platePriceRecord.guid] = platePriceRecord;
      }
    },
  },
});

export const { setPlatePrices } = platePricesSlice.actions;
export const platePrices = platePricesSlice.reducer;
